import { useRouter } from 'next/router';
import classNames from 'classnames';

import { ActiveLink } from '@/ui/index';

import styles from './styles.module.scss';

const SingleTariffsTabs = ({ tabs }) => {
  const router = useRouter();
  const renderTab = (tab, key) => {
    return (
      <div
        className={classNames([
          styles.item,
          { [styles.active]: router.asPath.substring(1) === tab?.slug },
        ])}
        key={key}
        itemScope
        itemType='http://schema.org/ListItem'
      >
        <ActiveLink href={tab?.slug}>
          <a title={tab?.text} aria-label={tab?.text}>
            {tab?.text}
          </a>
        </ActiveLink>
      </div>
    );
  };
  return (
    <div
      className={styles.container}
      itemScope
      itemType='http://schema.org/ItemList'
    >
      <div className={'wrapper'}>
        <div className={styles.list}>
          {tabs?.map((tab, key) => renderTab(tab, key))}
        </div>
      </div>
    </div>
  );
};

export default SingleTariffsTabs;
